import { Injectable } from '@jkhy/frontend-utils/di';
import { NavigationModelDto, NavigationsClient } from '@treasury/api/channel';
import { ApplicationArea } from './application-area.type';

@Injectable()
export class ApplicationAreaService {
    constructor(private navigationsClient: NavigationsClient) {}

    public navigationTree: NavigationModelDto[] = [];

    private initialized = false;

    public async init() {
        if (this.initialized) {
            return;
        }
        this.navigationTree = (
            await this.navigationsClient.navigationsGet({ maxAgeInSeconds: 30 })
        ).data;
        this.initialized = true;
    }

    public hasMenuPermission(permitKey: ApplicationArea) {
        if (!this.initialized) {
            throw new Error('Menu service is not initialized.');
        }

        return !!this.navigationTree.find(x => x.key === permitKey);
    }

    public reset() {
        this.navigationTree = [];
        this.initialized = false;
    }
}
